import styled from 'styled-components';

import {
  black,
  blue,
  green,
  lightGray,
  lightGreen,
  mediumGray,
  orange,
  purple,
  red,
  white,
  yellow,
} from '../../modules/colors';
import { spacing } from '../../modules/metrics';

const options = {
  borderLeftColor: {
    black,
    blue,
    lightGray,
    green,
    mediumGray,
    lightGreen,
    orange,
    purple,
    red,
    white,
    yellow,
  },
  border: {
    small: 4,
    medium: 10,
  },
};

export const Wrapper = styled.div`
  background-color: ${white};
  border-radius: ${(props) =>
    props.statusSize === 'small' ? `${spacing.sm}px` : `${spacing.md}px`};
  ${(props) => props.border && `border: 1px solid ${lightGray};`}
  ${(props) =>
    props.statusColor &&
    `border-left: ${options.border[props.statusSize]}px solid ${
      options.borderLeftColor[props.statusColor]
    };`};
  ${(props) => props.onClick && 'cursor: pointer;'};
  ${(props) => props.disabled && 'opacity: 0.3;'};
  ${(props) => props.disabled && 'pointer-events: none;'};
  ${(props) => props.shadow && 'box-shadow: 7px 8px 6px rgb(208, 212, 221);'}
  padding: ${spacing.sm}px ${spacing.lg}px;
  width: 100%;
  transition: all 0.5s;
  transition-property: opacity, box-shadow;

  ${(props) =>
    props.onClick && ':hover { box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }'}
`;
